var map = {
	"./flags/japan.png": 59714,
	"./flags/united-kingdom.png": 56465,
	"./fonts.css": 79974,
	"./fonts/SSTUI-Roman.ttf": 82526,
	"./fonts/SSTUI-Roman.woff": 73758,
	"./fonts/SSTUI-Roman.woff2": 58008,
	"./icons.css": 76622,
	"./icons/icon.svg": 99628,
	"./icons/icon.ttf": 86029,
	"./icons/icon.woff": 86371,
	"./logo_black.svg": 19507,
	"./logo_white.svg": 25945,
	"./nucleus-logo-1.svg": 85729,
	"./nucleus-logo-2.svg": 97042,
	"./tailwind.css": 67246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;